import { events, on, queryProvider, serviceQueries } from 'elc-service-bus';
import { PowerReviewsInitializedUseCase } from '../internal/use-cases/PowerReviewsInitializedUseCase';
import { ReadReviewsClickedUseCase } from '../internal/use-cases/ReadReviewsClickedUseCase';
import { WriteReviewClickedUseCase } from '../internal/use-cases/WriteReviewClickedUseCase';
import { ProductFullLoadedUseCase } from '../internal/use-cases/ProductFullLoadedUseCase';
import { ReviewSnippetRepository } from '../internal/repositories/ReviewSnippetRepository';
import { IReviewsPayload } from '../internal/interfaces/IReviews';

interface IProductFullLoaded {
    productId: string;
    skuId: string;
}
export class ServiceBusController {
    private reviewSnippetRepository: ReviewSnippetRepository;

    constructor(reviewSnippetRepository: ReviewSnippetRepository) {
        this.reviewSnippetRepository = reviewSnippetRepository;
    }

    @on(events.SPP_POWER_REVIEWS_INIT)
    public powerReviewsInitialized = async (productId: string) => {
        const powerReviewsInitializedUseCase = new PowerReviewsInitializedUseCase(productId);
        await powerReviewsInitializedUseCase.execute();
    };

    @on(events.READ_REVIEWS_LINK_CLICKED)
    public readReviewsLinkClicked = () => {
        const readReviewsLinkClickedUseCase = new ReadReviewsClickedUseCase();
        readReviewsLinkClickedUseCase.execute();
    };

    @on(events.WRITE_REVIEWS_LINK_CLICKED)
    public writeReviewsLinkClicked = (reviewInfo: IReviewsPayload) => {
        const writeReviewsLinkClickedUseCase = new WriteReviewClickedUseCase(reviewInfo);
        writeReviewsLinkClickedUseCase.execute();
    };

    @on(events.PRODUCT_FULL_LOADED)
    public productFullLoaded = ({ productId, skuId }: IProductFullLoaded) => {
        const productFullLoadedUseCase = new ProductFullLoadedUseCase(productId, skuId);
        productFullLoadedUseCase.execute();
    };

    @queryProvider(serviceQueries.GET_REVIEW_SNIPPET)
    public getReviewSnippets = async (pageIds: string[]) => {
        return this.reviewSnippetRepository.getReviewSnippet(pageIds);
    };
}
